import { uploadImage } from "@/services/upload";
import { Add } from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";

export default function NewExperienceContainer({ meta, setMeta }) {
  const [title, setTitle] = useState("");
  const [location, setLocation] = useState("");
  const [when, setWhen] = useState("");
  const [file, setFile] = useState(null);

  const handleFileChange = async () => {
    const cover = await uploadImage(file);
    setMeta((prev) => ({ ...prev, cover }));
  };

  useEffect(() => {
    if (file) {
      handleFileChange();
    }
  }, [file]);

  useEffect(() => {
    setMeta((prev) => ({ ...prev, title, location, when }));
  }, [title, location, when]);

  // const isDisabled = !title || !location || !when || mutation.isPending;

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          gap: 4,
          mt: 2,
        }}
      >
        <Card id="experience-container" style={{ borderRadius: "20px" }}>
          <CardContent>
            {!file && (
              <Box>
                <label htmlFor="icon-button-file-merch">
                  <Button
                    variant="outlined"
                    color="secondary"
                    component="span"
                    fullWidth
                    style={{ borderRadius: "25px" }}
                    startIcon={<Add />}
                  >
                    Add Photo
                  </Button>
                </label>
                <input
                  accept="image/*"
                  style={{ display: "none" }}
                  id="icon-button-file-merch"
                  type="file"
                  // multiple
                  onChange={(e) => setFile(e.target.files[0])}
                />
              </Box>
            )}

            <CardMedia
              component="img"
              src={file ? URL.createObjectURL(file) : ""}
              style={{ borderRadius: "10px" }}
              sx={{ my: 2 }}
            />
            <TextField
              fullWidth
              required
              label="Experience Title"
              value={title}
              autoComplete="off"
              variant="standard"
              color="secondary"
              style={{ marginBottom: "20px" }}
              onChange={(e) => setTitle(e.target.value)}
            />

            <TextField
              fullWidth
              required
              label="Location"
              value={location}
              autoComplete="off"
              variant="standard"
              color="secondary"
              style={{ marginBottom: "20px" }}
              onChange={(e) => setLocation(e.target.value)}
            />

            <TextField
              fullWidth
              label="When"
              // type="datetime-local"
              // value={datetime.toISOString().split(":").slice(0, 2).join(":")}
              value={when}
              placeholder={`e.g. Oct 4th-12th, ${new Date().getFullYear()}`}
              autoComplete="off"
              variant="standard"
              color="secondary"
              style={{ marginBottom: "20px" }}
              // onChange={(e) => setDatetime(new Date(e.target.value))}
              onChange={(e) => setWhen(e.target.value)}
              required
            />
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
}
